import { EmptyState, Loading } from '@cubeyou-team/hx-react-components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { QUERY_TYPE_IDS } from '@discover-frontend/constants';
import translations from '../../lang';
import { getRootFolder } from '../../mappers';
import { EmptyRepositoryCampaignContainer } from '../../modules/audience-activation/components/EmptyRepositoryCampaignContainer';
import FoldersBreadcrumbs from '../FoldersBreadcrumbs';
import { StyledFoldersNavigationContainer } from './FoldersNavigation.styles';
import FoldersContent from './components/FoldersContent';

class FoldersNavigation extends Component {
  _defer = null;

  constructor(props) {
    super(props);
    this.state = {
      navigation: this.props.initialPath || [
        {
          ...getRootFolder(this.props.filter),
        },
      ],
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filter !== this.props.filter ||
      prevProps.targetQ !== this.props.targetQ ||
      JSON.stringify(prevProps.initialPath) !==
        JSON.stringify(this.props.initialPath)
    ) {
      this.setState({
        ...this.state,
        navigation: this.props.initialPath || [
          getRootFolder(this.props.filter),
        ],
      });
    }
  }

  handleCurrentPathIds = navTo => {
    const { navigation } = this.state;
    let newIds = [...navigation];
    if (!navTo) {
      newIds = [];
    } else {
      if (newIds.find(item => item.id === navTo.id)) {
        const index = newIds.findIndex(item => item.id === navTo.id);
        newIds.length = index + 1;
      } else {
        newIds = [...newIds, navTo];
      }
    }

    this.setState({
      ...this.state,
      navigation: newIds,
    });
    return newIds;
  };

  render() {
    const {
      treeView,
      filter,
      isSearching,
      isInitialLoading,
      shouldCallLoadMore,
      size,
    } = this.props;
    const { navigation } = this.state;

    if (isInitialLoading) {
      return (
        <StyledFoldersNavigationContainer data-test-id="folders-navigation-container">
          <Loading isLoading>Loading</Loading>
        </StyledFoldersNavigationContainer>
      );
    }

    const isItemLoaded = index =>
      !shouldCallLoadMore[filter] || index < treeView.length;

    if (isSearching && treeView.length === 0 && navigation.length === 1) {
      return (
        <StyledFoldersNavigationContainer data-test-id="folders-navigation-container">
          <FoldersBreadcrumbs
            navigation={navigation}
            onNavigationClick={(item, loaded) => {
              const path = this.handleCurrentPathIds(item);
              this.props.onNavigationClick(
                item ? item : getRootFolder(),
                path,
                loaded
              );
            }}
          />
          <EmptyState
            icon="search"
            mainText={translations['en-US'].COMMON.NOT_FOUND_ITEM}
            size="small"
            smallText={translations['en-US'].COMMON.TRY_AGAIN}
          />
        </StyledFoldersNavigationContainer>
      );
    }

    if (!treeView || treeView.length === 0) {
      return (
        <StyledFoldersNavigationContainer data-test-id="folders-navigation-container">
          <FoldersBreadcrumbs
            navigation={navigation}
            onNavigationClick={(item, loaded) => {
              const path = this.handleCurrentPathIds(item);
              this.props.onNavigationClick(
                item ? item : getRootFolder(),
                path,
                loaded
              );
            }}
          />
          {filter === QUERY_TYPE_IDS.CAMPAIGN ? (
            <EmptyRepositoryCampaignContainer />
          ) : (
            <EmptyState
              icon="folder"
              mainText={translations['en-US'].FOLDER_NAVIGATION.EMPTY_FOLDER}
              size="small"
            />
          )}
        </StyledFoldersNavigationContainer>
      );
    }

    return (
      <StyledFoldersNavigationContainer data-test-id="folders-navigation-container">
        <FoldersBreadcrumbs
          navigation={navigation}
          onNavigationClick={(item, loaded) => {
            const path = this.handleCurrentPathIds(item);
            this.props.onNavigationClick(
              item ? item : getRootFolder(),
              path,
              loaded
            );
          }}
        />
        <FoldersContent
          extended={size === 'full'}
          items={treeView}
          isItemLoaded={isItemLoaded}
          disableAudiences={this.props.disableAudiences}
          hideActions={this.props.hideActions}
          actions={this.props.actions}
          onFolderClick={(item, loaded) => {
            const path = this.handleCurrentPathIds(item);
            this.props.onNavigationClick(
              item ? item : getRootFolder(),
              path,
              loaded
            );
          }}
          onItemDragToggle={this.props.onItemDragToggle}
        />
      </StyledFoldersNavigationContainer>
    );
  }
}

FoldersNavigation.propTypes = {
  treeView: PropTypes.array,
  actions: PropTypes.object,
  filter: PropTypes.string,
  disableAudiences: PropTypes.bool,
  hideActions: PropTypes.bool,
  isNextPageLoading: PropTypes.bool,
  isInitialLoading: PropTypes.bool,
  shouldCallLoadMore: PropTypes.object,
  onLoadMoreRequest: PropTypes.func,
  onNavigationClick: PropTypes.func,
  initialPath: PropTypes.array,
};

FoldersNavigation.defaultProps = {
  treeView: [],
  hideActions: true,
};

export default FoldersNavigation;
